module.exports = __webpack_public_path__ + "media/click_delete.dd7d13b4.wav";